import { render, staticRenderFns } from "./ProfileChart.vue.html?vue&type=template&id=4aa4e0c1&lang=html&external"
import script from "./ProfileChart.vue.js?vue&type=script&lang=js&external"
export * from "./ProfileChart.vue.js?vue&type=script&lang=js&external"
import style0 from "./ProfileChart.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports